exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h4 {\n    font-size: 16px;\n    background: #dee7ff !important;\n    height: 40px;\n    line-height: 40px;\n    margin-bottom: 0;\n    width: 100%;\n    padding-left: 15px;\n}\n\n.group-box {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: end;\n        -ms-flex-align: end;\n            align-items: flex-end;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/bizisystem-frontend/src/src/app/main/frames/organization-parameter/organization-parameter.component.css
// module id = ../../../../../src/app/main/frames/organization-parameter/organization-parameter.component.css
// module chunks = main